import { render, staticRenderFns } from "./addThreeLogin.vue?vue&type=template&id=88091fc4&scoped=true&"
import script from "./addThreeLogin.vue?vue&type=script&lang=js&"
export * from "./addThreeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88091fc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88091fc4')) {
      api.createRecord('88091fc4', component.options)
    } else {
      api.reload('88091fc4', component.options)
    }
    module.hot.accept("./addThreeLogin.vue?vue&type=template&id=88091fc4&scoped=true&", function () {
      api.rerender('88091fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/addThreeLogin.vue"
export default component.exports